<template>
    <div v-if="budget && isAuthorized" id="Menu">
        <v-tabs
            v-model="activeTab"
            style="background: #f4f4f4; border-radius: 16px; overflow: hidden"
        >
            <!-- <v-tabs-slider></v-tabs-slider> -->
            <v-tab v-if="budget && budget.accountingLines" value="Charts" href="#Charts"
                >Graphiques</v-tab
            >
            <v-tab v-if="budget && budget.accountingLines" value="CashFlowPlan" href="#CashFlowPlan"
                >Plan de trésorerie</v-tab
            >
            <v-tab v-if="budget && budget.accountingLines" value="Forecast" href="#Forecast"
                >Atterrissage</v-tab
            >
            <v-tab
                v-if="isAccountingUser && budget && budget.accountingLines"
                value="AccountableAccount"
                href="#AccountableAccount"
                >Comptes Comptables</v-tab
            >
            <v-tab value="fixedAssets" href="#fixedAssets">Investissements et financements</v-tab>
            <v-tab value="socialCharge" href="#socialCharge">Salaires</v-tab>
            <v-tab value="amortisation" href="#amortisation">Amortissements</v-tab>
            <v-tab value="incomeStatement" href="#incomeStatement">Compte de résultat</v-tab>
            <v-tab value="wcr" href="#wcr">BFR</v-tab>
        </v-tabs>

        <v-tabs-window v-model="activeTab">
            <!-- TABLEAU -->
            <!-- <v-tabs-window-item v-if="budget && budget.accountingLines" key="ActualAccountableAccount" value="ActualAccountableAccount">
                <template v-if="statsPurchaseAccountableAccountMonthlyLoading">
                    <v-progress-circular
                        :size="70"
                        :width="7"
                        color="primary"
                        indeterminate
                        style="margin:24px"
                    ></v-progress-circular>
                </template>
                <v-data-table
                    :headers="statsSalesPurchaseAccountableAccountMonthly.labels"
                    :items="statsSalesPurchaseAccountableAccountMonthly.datasets"
                    :items-per-page-options="[5, 10, 25]"
                    class="table mt-2"
                    fixed-header
                    height="60vh"
                    dense
                    v-if="statsSalesPurchaseAccountableAccountMonthly"
                >
                    <template v-slot:item="props">
                        <tr>
                            <td>{{props.item.label}}</td>
                            <td v-for="(item, i) in props.item.data" :key="i">
                                <p >{{newCommonFormatCurrency(item, undefined)}}</p>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-tabs-window-item> -->
            <!-- GRAPH -->
            <v-tabs-window-item v-if="datasets" value="Charts">
                <v-row>
                    <v-col>
                        <BarChartCard
                            ref="cashFlowChart"
                            :title="$t('shared.cashFlow')"
                            :legend="true"
                            :loading="cashFlowBudgetLoading"
                            :data="cashFlowBudgetData"
                            :activeBack="false"
                            :selectedPeriod="selectedPeriod"
                            :yearNMinus1="false"
                        >
                        </BarChartCard>
                    </v-col>
                    <v-col>
                        <BarChartCard
                            ref="profitAndLossForecastVersusActual"
                            :title="$t('shared.profitAndLossForecastVersusActual')"
                            :legend="true"
                            :loading="forecastBudgetWithActualLoading"
                            :data="profitAndLossForecastVersusActualData"
                            :activeBack="false"
                            :selectedPeriod="selectedPeriod"
                            :yearNMinus1="false"
                        >
                        </BarChartCard>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <BarChartCard
                            ref="salesForecastVersusActual"
                            :title="$t('shared.salesForecastVersusActual')"
                            :legend="true"
                            :loading="forecastBudgetWithActualLoading"
                            :data="salesForecastVersusActualData"
                            :activeBack="false"
                            :selectedPeriod="selectedPeriod"
                            :yearNMinus1="false"
                        >
                        </BarChartCard>
                    </v-col>
                    <v-col>
                        <BarChartCard
                            ref="purchaseForecastVersusActual"
                            :title="$t('shared.purchaseForecastVersusActual')"
                            :legend="true"
                            :loading="forecastBudgetWithActualLoading"
                            :data="purchaseForecastVersusActualData"
                            :activeBack="false"
                            :selectedPeriod="selectedPeriod"
                            :yearNMinus1="false"
                        >
                        </BarChartCard>
                    </v-col>
                </v-row>
            </v-tabs-window-item>
            <!-- CASHFLOW PLAN -->
            <v-tabs-window-item v-if="datasets" value="CashFlowPlan">
                <div style="width: 100%">
                    <CashFlowPlan
                        :companyId="companyId"
                        :inBudgetId="budgetId"
                        :selectedPeriod="selectedPeriod"
                        :refreshData="refreshData"
                    >
                    </CashFlowPlan>
                </div>
            </v-tabs-window-item>
            <v-tabs-window-item v-if="datasets" value="Forecast">
                <v-row no-gutters class="mt-4 d-flex justify-center">
                    <v-col cols="4">
                        <v-select
                            outlined
                            v-model="forecastMonth"
                            :items="forecastMonths"
                            label="Période"
                            item-value="value"
                            hide-details
                            density="compact"
                            :item-title="(item) => item.name"
                        />
                    </v-col>
                </v-row>
                <v-row no-gutters class="mt-2 d-flex justify-center">
                    <v-col cols="4">
                        <!-- <v-card-text style="text-align:center;" class="pa-0"> -->
                        <template v-if="forecastBudgetWithActualLoading">
                            <v-progress-circular
                                :size="70"
                                :width="7"
                                color="primary"
                                indeterminate
                                style="margin: 24px"
                            />
                        </template>
                        <template v-else-if="forecastDetails && forecastDetails.length">
                            <v-data-table
                                :headers="forecastHeaders"
                                :items="forecastDetails"
                                v-model:items-per-page="forecastDetails.length"
                                class="table"
                                hide-default-footer
                            >
                                <template v-slot:item="props">
                                    <tr>
                                        <td
                                            class="text-left"
                                            :style="props.item.strong ? 'font-weight: bold' : ''"
                                        >
                                            {{ props.item.type }}
                                        </td>
                                        <td
                                            class="text-right"
                                            :style="props.item.strong ? 'font-weight: bold' : ''"
                                        >
                                            {{ formatAmount(props.item.value, 0) }}
                                        </td>
                                        <!-- <td class="text-center" :style="props.item.strong ? 'font-weight: bold':''">{{ formatAmount(props.item.value2, 0) }}</td> -->
                                    </tr>
                                </template>
                            </v-data-table>
                        </template>
                    </v-col>
                </v-row>
            </v-tabs-window-item>
            <v-tabs-window-item v-if="budget && budget.accountingLines" value="AccountableAccount">
                <v-data-table
                    :headers="headers"
                    :items="accountableAccountItems"
                    :items-per-page-options="[5, 10, 25]"
                    class="table mt-2"
                    fixed-header
                    height="60vh"
                    density="compact"
                >
                    <!-- HEADER TEMPLATE -->
                    <!-- <template v-slot:header="props">
                        <tr>
                            <td
                                v-for="(header, index) in headers"
                                :key="index"
                                style="width: 100px"
                            >
                                <b style="overflow-wrap: anywhere;">{{ header }}</b>
                            </td>
                        </tr>
                    </template> -->
                    <!-- BODY TEMPLATE -->
                    <template v-slot:item="props">
                        <tr>
                            <td v-for="(item, i) in props.item" :key="i">
                                <p v-if="i === 0">{{ item }}</p>
                                <p v-else class="text-right">
                                    {{ newCommonFormatCurrency(item, { currency: "" }) }}
                                </p>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-tabs-window-item>
            <v-tabs-window-item value="fixedAssets" class="pt-3">
                <AccountingTable
                    ref="fixedAssets"
                    :options="fixedAssetsOptions"
                    :budgetId="budgetId"
                    :periods="[]"
                >
                </AccountingTable>
            </v-tabs-window-item>
            <v-tabs-window-item value="amortisation" class="pt-3">
                <AccountingTable
                    ref="amortisation"
                    :options="amortisationOptions"
                    :budgetId="budgetId"
                    :periods="[]"
                >
                </AccountingTable>
            </v-tabs-window-item>
            <v-tabs-window-item value="socialCharge" class="pt-3">
                <AccountingTable
                    ref="socialCharge"
                    :options="socialChargeOptions"
                    :budgetId="budgetId"
                    :periods="[]"
                >
                </AccountingTable>
            </v-tabs-window-item>
            <v-tabs-window-item value="incomeStatement" class="pt-3">
                <AccountingTable
                    ref="incomeStatement"
                    :options="incomeStatementOptions"
                    :budgetId="budgetId"
                    :periods="[]"
                >
                </AccountingTable>
            </v-tabs-window-item>
            <v-tabs-window-item value="wcr" class="pt-3">
                <AccountingTable ref="bfr" :options="bfrOptions" :budgetId="budgetId" :periods="[]">
                </AccountingTable>
            </v-tabs-window-item>
        </v-tabs-window>
    </div>
</template>

<script lang="ts">
import ExcelJS from "exceljs";
import { User } from "../store/store";
import moment from "moment-timezone";
import { Apollo } from "@/decorators";

import BUDGET_DATA from "../graphql/budget/Budget.gql";
import CASHFLOW_BUDGET from "../graphql/budget/CashFlowBudget.gql";
import Compute_Forecast_With_Actual from "../graphql/budget/ComputeForecastWithActual.gql";

import BarChartCard from "./dashboard/BarChartCard.vue";
import CashFlowPlan from "./dashboard/CashFlowPlan.vue";
import AccountingTableComp, { AccountingTable } from "./dashboardAccounting/AccountingTable.vue";
// import BreakEvenPoint from "./BreakEvenPoint.vue";

// import { chartColors } from "../services/graphServices";
import { mathFix } from "../services/mathServices";
import { newCommonFormatCurrency } from "../../../backend/src/common/services/mathServices";
import { getDBFormattedEndDate, getDBFormattedStartDate } from "../services/dateServices";
import { checkAccessRights } from "../services/accessRightServices";
import ExcelServices from "@/services/excelServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

import emitter from "../services/emitter";

@Component({
    components: {
        BarChartCard,
        CashFlowPlan,
        AccountingTable: AccountingTableComp,
        // BreakEvenPoint,
    },
    emits: ["isDownloadable", "get-periods-list"],
})
export class BudgetDiagram extends Vue {
    @Prop({ default: "" }) budgetId: string;
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: "" }) startDate: string;
    @Prop({ default: 1 }) selectedPeriod: number;
    @Prop({ default: 0 }) refreshData: number; // counter incremented when data has to be refreshed

    @Prop() tableCSV: Array<Array<string>>;

    activeTab: string = "Charts";

    accountingTables = ["incomeStatement", "fixedAssets", "amortisation", "socialCharge", "wrc"];

    // budgetForm = null;

    periodsList = [];
    _startDate: string = null;
    _endDate: string = null;
    skipChartsQuery = true;
    skipCashFlowQuery = true;
    skipBudgetQuery = false;

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAccountingUser() {
        return this.currentUser.isAccountingUser;
    }

    get isAuthorized() {
        const authorized = checkAccessRights(this.currentUser, "budget", "read");
        return authorized;
    }

    get endDate() {
        if (this.startDate) {
            const end = moment(this.startDate)
                .add(12, "months")
                .add(-1, "days")
                .format("YYYY-MM-DD");
            this._endDate = end;
            this._startDate = this.startDate;
            return end;
        }
        return "";
    }

    get fixedAssetsOptions() {
        return {
            title: "Immobilisations",
            className: "FixedAssets",
        };
    }

    get socialChargeOptions() {
        return {
            title: "Salaire",
            className: "SocialCharge",
        };
    }

    get incomeStatementOptions() {
        return {
            title: "Compte de résultat",
            className: "INCOME_STATEMENT",
        };
    }

    get amortisationOptions() {
        return {
            title: "Amortissement",
            className: "Amortisation",
        };
    }

    get bfrOptions() {
        return {
            title: "BFR",
            className: "WorkingCapitalRequirement",
        };
    }

    // get bepOptions() {
    //     return {
    //         title: "SDR",
    //         className: "BreakEvenPoint",
    //     };
    // }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    @Watch("selectedPeriod")
    onSelectedPeriodChanged() {
        this.selectPeriodFromBudget();
    }

    @Watch("budgetId")
    onBudgetIdChanged() {
        this.skipBudgetQuery = false;
    }

    @Watch("refreshData")
    onRefreshDataChanged() {
        this.skipBudgetQuery = false;
    }

    @Watch("activeTab")
    test() {
        const downloadableTabs = [
            "AccountableAccount",
            "incomeStatement",
            "fixedAssets",
            "amortisation",
            "socialCharge",
        ];
        if (downloadableTabs.includes(this.activeTab)) {
            this.$emit("isDownloadable", true);
        } else {
            this.$emit("isDownloadable", false);
        }
    }

    @Apollo({
        query: BUDGET_DATA,
        variables() {
            return {
                id: this.budgetId,
            };
        },
        skip() {
            return !this.isAuthorized || !this.budgetId || this.skipBudgetQuery;
        },
        async specificResult({ data, loading, networkStatus }: any) {
            this.loading = loading;
            if (!loading) {
                // debugger
                if (data.budget) {
                    this.budget = data.budget;
                    this.budget.accountingLines.sort((a, b) => {
                        const aDate = moment(a.date);
                        const bDate = moment(b.date);
                        if (aDate.isBefore(bDate)) return -1;
                        if (aDate.isAfter(bDate)) return 1;
                        return 0;
                    });
                    this.emitPeriodsList();
                    this.selectPeriodFromBudget();
                    this.skipBudgetQuery = true;
                } else {
                    this.budget = null;
                    // this.budgetForm = null;
                }
            }
        },
    })
    budget: any = null;

    // get threeYearsHeaders() {
    //     const headers = this.budgetForm.getThreeYearsHeaders();
    //     return headers.map(h => ({ text: this.$t("budget." + h) }))
    // }

    formatAmount(value, dec: number = 2) {
        if (value === 0) {
            return "-";
        }
        if (value !== "") {
            return mathFix(value, dec) + " €";
        }
        return "";
    }

    @Apollo({
        query: CASHFLOW_BUDGET,
        variables() {
            return {
                budgetId: this.budgetId,
                startDate: getDBFormattedStartDate(this._startDate),
                endDate: getDBFormattedEndDate(this._endDate),
            };
        },
        skip() {
            return !this.isAuthorized || !this.budgetId || this.skipCashFlowQuery;
        },
        specificResult({ data, loading, networkStatus }: any) {
            // debugger
            this.cashFlowBudgetLoading = loading;
            if (!loading) {
                if (data && data.cashFlowBudget) {
                    this.cashFlowBudgetData = data.cashFlowBudget;
                    this.skipCashFlowQuery = true;
                    // this.emitPeriodsList(data.cashFlowBudget.study)
                }
            }
        },
    })
    cashFlowBudgetData: any = null;

    cashFlowBudgetLoading: boolean = false;

    //
    //
    //
    @Apollo({
        query: Compute_Forecast_With_Actual,
        variables() {
            return {
                budgetId: this.budgetId,
                startDate: getDBFormattedStartDate(this._startDate),
                endDate: getDBFormattedEndDate(this._endDate),
            };
        },
        skip() {
            return !this.isAuthorized || !this.budgetId || this.skipChartsQuery;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.forecastBudgetWithActualLoading = loading;
            if (!loading) {
                if (
                    data &&
                    data.computeForecastWithActual &&
                    data.computeForecastWithActual.result
                ) {
                    this.forecastBudgetWithActualData = data.computeForecastWithActual.result;
                    this.purchaseForecastVersusActualData = {
                        labels: this.forecastBudgetWithActualData.budgetData.labels,
                        datasets: [
                            {
                                label: "Prévisionnelles",
                                data: this.forecastBudgetWithActualData.budgetData.purchases,
                            },
                            {
                                label: "Réelles",
                                data: this.forecastBudgetWithActualData.actualData.purchases,
                            },
                        ],
                        study: this.forecastBudgetWithActualData.study,
                    };
                    this.salesForecastVersusActualData = {
                        labels: this.forecastBudgetWithActualData.budgetData.labels,
                        datasets: [
                            {
                                label: "Prévisionnelles",
                                data: this.forecastBudgetWithActualData.budgetData.sales,
                            },
                            {
                                label: "Réelles",
                                data: this.forecastBudgetWithActualData.actualData.sales,
                            },
                        ],
                        study: this.forecastBudgetWithActualData.study,
                    };

                    this.profitAndLossForecastVersusActualData = {
                        labels: this.forecastBudgetWithActualData.budgetData.labels,
                        datasets: [
                            {
                                label: "Prévisionnelles",
                                data: JSON.parse(
                                    JSON.stringify(
                                        this.forecastBudgetWithActualData.budgetData.sales,
                                    ),
                                ),
                            },
                            {
                                label: "Réelles",
                                data: JSON.parse(
                                    JSON.stringify(
                                        this.forecastBudgetWithActualData.actualData.sales,
                                    ),
                                ),
                            },
                        ],
                        study: this.forecastBudgetWithActualData.study,
                    };
                    for (
                        let i = 0;
                        i < this.forecastBudgetWithActualData.budgetData.purchases.length;
                        i++
                    ) {
                        this.profitAndLossForecastVersusActualData.datasets[0].data[i] +=
                            this.forecastBudgetWithActualData.budgetData.purchases[i];
                    }
                    for (
                        let i = 0;
                        i < this.forecastBudgetWithActualData.actualData.purchases.length;
                        i++
                    ) {
                        this.profitAndLossForecastVersusActualData.datasets[1].data[i] +=
                            this.forecastBudgetWithActualData.actualData.purchases[i];
                    }
                    this.skipChartsQuery = true;
                } else {
                    this.forecastBudgetWithActualData = null;
                    this.purchaseForecastVersusActualData = null;
                    this.salesForecastVersusActualData = null;
                    this.profitAndLossForecastVersusActualData = null;
                }
            }
        },
    })
    forecastBudgetWithActualData: any = null;

    forecastBudgetWithActualLoading: boolean = false;

    purchaseForecastVersusActualData: any = null;

    salesForecastVersusActualData: any = null;

    profitAndLossForecastVersusActualData: any = null;

    forecastHeaders = [
        { title: "Description", value: "type", sortable: false, align: "start" },
        { title: "Prévision", value: "value", sortable: false, align: "end" },
        // { text: "Prévision ajustée", value: "value2", sortable: false, align: "center" }
    ];

    forecastMonth: string = "end";

    get forecastMonths() {
        const currentMonth = "Fin " + moment().format("MMMM");
        return [
            { name: currentMonth, value: "now" },
            { name: "Fin d'exercice", value: "end" },
        ];
    }

    get forecastDetails() {
        const forecastDetails = [];
        if (
            this.forecastMonth &&
            this.forecastBudgetWithActualData &&
            this.forecastBudgetWithActualData.forecastData &&
            this.forecastBudgetWithActualData.forecastData.forecast &&
            this.forecastBudgetWithActualData.forecastData.forecast[this.forecastMonth]
        ) {
            const forecast =
                this.forecastBudgetWithActualData.forecastData.forecast[this.forecastMonth];
            forecastDetails.push({
                type: "Chiffre d'affaires",
                value: forecast.currentMonth.sales,
                value2: forecast.currentMonth2.sales,
                strong: true,
            });
            forecastDetails.push({
                type: "Marge Brute",
                value: forecast.currentMonth.margin,
                value2: forecast.currentMonth2.margin,
                strong: true,
            });
            forecastDetails.push({ type: "Charges Fixes", value: "", value2: "", strong: true });
            forecastDetails.push({
                type: "Salaires",
                value: forecast.currentMonth.socialCharges,
                value2: forecast.currentMonth2.socialCharges,
            });
            forecastDetails.push({
                type: "Location",
                value: forecast.currentMonth.rentals,
                value2: forecast.currentMonth2.rentals,
            });
            forecastDetails.push({
                type: "Frais généraux (hors location)",
                value: forecast.currentMonth.generalExpenses,
                value2: forecast.currentMonth2.generalExpenses,
            });
            forecastDetails.push({
                type: "Impôts et taxes",
                value: forecast.currentMonth.taxs,
                value2: forecast.currentMonth2.taxs,
            });
            forecastDetails.push({
                type: "Divers",
                value: forecast.currentMonth.miscellaneous,
                value2: forecast.currentMonth2.miscellaneous,
            });
            forecastDetails.push({
                type: "Amortissements",
                value: forecast.currentMonth.amortisations,
                value2: forecast.currentMonth2.amortisations,
                strong: true,
            });
            forecastDetails.push({
                type: "Résultat d'exploitation",
                value: forecast.currentMonth.ebit,
                value2: forecast.currentMonth2.ebit,
                strong: true,
            });
            // forecastDetails.push({ type: "Impôt sur les sociétés", value: forecast.currentMonth.corporateTax, value2: forecast.currentMonth2.corporateTax, strong: true });
        }
        return forecastDetails;
    }

    get name() {
        if (this.budget) {
            return this.budget.name;
        }
        return "Sélectionnez un scénario";
    }

    get dates() {
        const dates = [];
        if (this.budget) {
            for (const budg of this.budget.accountingLines) {
                const date = moment(budg.date).format("MM-YYYY");
                if (dates.indexOf(date) === -1) {
                    dates.push(date);
                }
            }
        }
        return dates;
    }

    get accountableAccounts() {
        if (this.budget && this.budget.accountingLines) {
            const accountableAccounts = [];
            for (const al of this.budget.accountingLines) {
                if (
                    al.amountSigned &&
                    accountableAccounts.indexOf(al.accountableAccount.name) === -1
                ) {
                    accountableAccounts.push(al.accountableAccount.name);
                }
            }
            // const removeDuplicates = list => list.reduce(
            //     (r, i) => (!r.some(j => i === j) ? [...r, i] : r),
            //     []
            // );
            // return removeDuplicates(
            //     this.budget.accountingLines.map(x => x.accountableAccount.name)
            // ).sort();
            return accountableAccounts;
        }
        return [];
    }

    get datasets() {
        // debugger
        if (!this.dates || !this.dates.length || !this.budget) {
            debugger;
            return [];
        }

        const dicoDates = {};
        // const dicoAcc = {};
        // const dataTable: Array<Array<string>> = [["Comptes", ...this.dates]];
        const dataTable = [];
        this.dates.forEach((lab, index) => {
            dicoDates[lab] = index + 1;
        });

        for (const al of this.budget.accountingLines) {
            if (!al.amountSigned) {
                continue;
            }
            const acc = al.accountableAccount.name;
            let row = dataTable.find((row) => row[0] === acc);
            if (!row) {
                row = [acc, ...new Array(this.dates.length).fill(0)];
                dataTable.push(row);
            }
            const date = moment(al.date).format("MM-YYYY");
            // const index = dicoAcc[acc];
            const indexDate = dicoDates[date];
            if (indexDate !== undefined) {
                row[indexDate] += al.amountSigned;
            } else {
                debugger;
            }
        }
        return dataTable;
    }

    get headers() {
        if (this.budgetId) {
            return [
                { title: "Comptes", value: "accountableAccount", sortable: false, align: "left" },
                ...this.dates.map((d) => ({ title: d, value: d, sortable: false, align: "right" })),
            ];
        }
        return [];
    }

    get accountableAccountItems() {
        if (this.budgetId) {
            return this.datasets; //.slice(1, this.datasets.length);
        }
        if (this.tableCSV) {
            return this.tableCSV; //.slice(1, this.datasets.length);
        }
        return null;
    }

    created() {
        emitter.$on("download-excel", this.exportExcel);
    }

    accountableAccountSum(table: Array<Array<string>>) {
        const result: Array<Array<number>> = [];
        let buffer: Array<number> = new Array(table[0].length - 1).fill(0);
        let accbleAccNum: string = table[1][0].slice(0, 2);

        for (let i = 1; i < table.length; i++) {
            if (accbleAccNum === table[i][0].slice(0, 2)) {
                for (let j = 0; j < buffer.length; j++) {
                    buffer[j] += Number(table[i][j + 1]);
                }
            } else {
                result.push(buffer);
                accbleAccNum = table[i][0].slice(0, 2);
                buffer = new Array(table[0].length - 1).fill(0);
                for (let j = 0; j < buffer.length; j++) {
                    buffer[j] = Number(table[i][j + 1]);
                }
            }
        }
        result.push(buffer);
        return result;
    }

    getBarChartLabels(table: Array<Array<string>>) {
        const result: Array<string> = [];
        let buffer: string = "";
        table.slice(1, table.length).forEach((datas) => {
            if (datas[0].slice(0, 2) !== buffer) {
                result.push(datas[0].slice(0, 2).concat("XXXX"));
                buffer = datas[0].slice(0, 2);
            }
        });
        return result;
    }

    // async getAccountableAccountV2(items: any) {
    //     const accountableAccounts = {};
    //     const accAccount = await this.$apollo.query({
    //         query: ACCOUNTABLE_ACCOUNT_V2,
    //         variables: {
    //             name: items
    //         }
    //     });
    //     console.log(accAccount);
    //     if (accAccount.data && accAccount.data.accountableAccounts) {
    //         accAccount.data.accountableAccounts.forEach((acc) => {
    //             accountableAccounts[acc.name] = acc.description;
    //         });
    //     }
    //     return accountableAccounts;
    // }

    pdfLoading: boolean = false;
    img: any = null;

    async recAddImageToPDF(pdf, indice, refs, height) {
        // if (indice >= refs.length) {
        //     pdf.save(this.budgetId + '.pdf');
        //     this.pdfLoading = false;
        //     return;
        // }
        // const self = this;
        // const elem = refs[indice].ownerDocument ? refs[indice] : refs[indice].$el;
        // if (elem) {
        //     try {
        //         const options = {
        //             type: 'dataURL'
        //         }
        //         const imgData = await this.$html2canvas(elem, options);
        //         const pdfWidth = pdf.internal.pageSize.getWidth();
        //         const pdfHeight = pdf.internal.pageSize.getHeight();
        //         // const imgData = canvas.toDataURL('image/png');
        //         // window.open(imgData);
        //         // this.img = imgData;
        //         const imgProps = pdf.getImageProperties(imgData);
        //         const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;
        //         let y = height;
        //         if (height + imgHeight > pdfHeight) {
        //             y = 0;
        //             pdf.addPage();
        //         }
        //         pdf.addImage(imgData, 'PNG', 0, y, pdfWidth, imgHeight);
        //         // pdf.addImage(imgData, 'PNG', 0, y, pdfWidth, imgHeight, null, 'NONE');
        //         // next
        //         this.recAddImageToPDF(pdf, indice + 1, refs, y + imgHeight);
        //     } catch (e) {
        //         console.error(e);
        //         this.recAddImageToPDF(pdf, indice + 1, refs, height);
        //     }
        //     // });
        // } else {
        //     console.error("elem without ownerDocument")
        //     this.recAddImageToPDF(pdf, indice + 1, refs, height);
        // }
    }

    addNumber(ws, row, col, value, style) {
        try {
            if (value !== null) {
                if (value === "") {
                    ws.cell(row, col).number(0).style(style);
                } else if (typeof value === "string") {
                    // debugger;
                    // console.error("value is string value= " + value);
                    ws.cell(row, col).number(parseFloat(value)).style(style);
                } else {
                    ws.cell(row, col).number(value).style(style);
                }
            }
        } catch (e) {
            console.error(e);
        }
    }

    // addThreeYearTable(wb, prefix, sheetName, salaryTable, styles) {
    //     const options = {};
    //     const ws = wb.addWorksheet(sheetName, options);
    //     let col = 1;
    //     for (const header of this.threeYearsHeaders) {
    //         ws.cell(1, col).string(header.text).style(styles.title);
    //         col++
    //     }
    //     let row = 2;
    //     for (const item of salaryTable) {
    //         const name = this.$t(prefix + item.name);
    //         if (item.type === "title") {
    //             ws.cell(row, 1).string(name).style(styles.title);
    //         } else {
    //             ws.cell(row, 1).string(name).style(item.type === "titled" ? styles.textBold : styles.text);
    //             const number = item.type === "titled" ? styles.numberBold : styles.number
    //             this.addNumber(ws, row, 2, item.year1, number);
    //             this.addNumber(ws, row, 3, item.year2, number);
    //             this.addNumber(ws, row, 4, item.year3, number);
    //         }
    //         row++;
    //     }
    // }

    excelLoading: boolean = false;

    applyProperties(row, font, fill, height) {
        if (row) {
            row.font = font;
            if (fill) row.fill = fill;
            if (height) row.height = 14;
            row.eachCell((cell, colNumber) => {
                // console.log('Cell ' + colNumber + ' = ' + cell.value);
                if (colNumber === 1) {
                    cell.alignment = { wrapText: true, vertical: "middle", horizontal: "left" };
                } else {
                    cell.alignment = { vertical: "middle", horizontal: "right" };
                }
            });
        } else {
            debugger;
        }
    }

    exportAccountablableAccounts(workbook, style) {
        const worksheet = workbook.addWorksheet("compte comptable", {
            views: [{ showGridLines: false }],
        });
        const firstCol = worksheet.getColumn(1);
        firstCol.width = 30;
        for (const values of this.accountableAccountItems) {
            const excelRow = [];
            // excelRow.push(row.name || row.title)
            for (let ci = 0; ci < values.length; ci++) {
                if (ci === 0) {
                    excelRow.push(values[ci]);
                } else {
                    excelRow.push(mathFix(values[ci], 2));
                }
            }
            worksheet.addRow(excelRow);
            this.applyProperties(worksheet.lastRow, style.normalFont, style.fill, style.height);
        }
    }

    async exportExcel() {
        this.excelLoading = true;

        const style = {
            height: 16,
            normalFont: { name: "Tahoma", family: 4, size: 10, bold: false },
            titleFont: { name: "Tahoma", family: 4, size: 10, bold: true },
            fill: { type: "pattern", pattern: "solid", fgColor: { argb: "eeeeee" } },
        };

        this.excelLoading = true;

        const date = new Date();
        const workbook = new ExcelJS.Workbook();
        workbook.creator = "bobbee";
        // workbook.lastModifiedBy = 'Her';
        workbook.created = date;
        // workbook.modified = new Date();
        // workbook.lastPrinted = new Date(2016, 9, 27);

        workbook.calcProperties.fullCalcOnLoad = true;

        if (this.activeTab === "AccountableAccount") {
            this.exportAccountablableAccounts(workbook, style);
        } else {
            const excel = new ExcelServices();
            // const prevActiveTab = this.activeTab;
            const ref = this.$refs[this.activeTab] as AccountingTable;
            if (ref && ref.exportExcelInNewSheet) {
                ref.exportExcelInNewSheet(excel, workbook, style);
            }
        }

        const buffer = await workbook.xlsx.writeBuffer();
        const filename = this.budget.name + ".xlsx";
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.setAttribute("style", "display:none");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
        this.excelLoading = false;
    }

    // emitPeriodsList(study) {
    //     const periods = [];
    //     const firstLine = {id: 1, name: "1er exercice"};
    //     periods.unshift(firstLine);
    //     for (let periodIndex = 2; periodIndex <= study.periodsNumber; periodIndex++) {
    //         const newLine = {id: periodIndex, name: periodIndex + "e exercice"};
    //         periods.push(newLine);
    //     }
    //     this.$emit('get-periods-list', periods);
    // }

    async emitPeriodsList() {
        // if (this.budgetId && !this.budget) {
        //     const resultB = await this.$apollo.query({
        //         query: BUDGET_QUERY,
        //         variables: {
        //             id: this.budgetId
        //         },
        //     });
        //     if (resultB.data && resultB.data.budget) {
        //         this.budget = resultB.data.budget;
        //     }
        if (this.budget && this.budget.parameters && this.budget.parameters.periodsNumber) {
            const periods = [];
            const firstLine = { id: 1, name: "1er exercice" };
            periods.unshift(firstLine);
            for (
                let periodIndex = 2;
                periodIndex <= this.budget.parameters.periodsNumber;
                periodIndex++
            ) {
                const newLine = { id: periodIndex, name: periodIndex + "e exercice" };
                periods.push(newLine);
            }
            this.$emit("get-periods-list", periods);
        } else if (
            this.budget &&
            this.budget.form &&
            this.budget.form.study &&
            this.budget.form.study.periodsNumber
        ) {
            const periods = [];
            const firstLine = { id: 1, name: "1er exercice" };
            periods.unshift(firstLine);
            for (
                let periodIndex = 2;
                periodIndex <= this.budget.form.study.periodsNumber;
                periodIndex++
            ) {
                const newLine = { id: periodIndex, name: periodIndex + "e exercice" };
                periods.push(newLine);
            }
            this.$emit("get-periods-list", periods);
        }
        // }
    }

    selectPeriodFromBudget() {
        // return start and end parameters to pass to datasets.slice
        // if this computation is to heavy we can store an array with computed indexes and just find the correct return value in this array when selectedPeriod change
        let startValue = moment(this.budget.date);
        const firstMonthCount =
            this.budget.parameters && this.budget.parameters.firstPeriodMonthsNumber
                ? this.budget.parameters.firstPeriodMonthsNumber - 1
                : this.budget.form.study.firstPeriodMonthsNumber - 1;
        const periodsNumber =
            this.budget.parameters && this.budget.parameters.periodsNumber
                ? this.budget.parameters.periodsNumber
                : this.budget.form.study.periodsNumber;
        let endValue = moment(this.budget.date).add(firstMonthCount, "months");
        if (firstMonthCount && this.selectedPeriod > 1) {
            startValue = endValue.clone().add(1, "months");
            endValue = endValue.add(12, "months");
            if (this.selectedPeriod > 2) {
                startValue = endValue.clone().add(1, "months");
                endValue = endValue.add(12, "months");
                if (this.selectedPeriod > 3) {
                    startValue = endValue.clone().add(1, "months");
                    endValue = endValue.add(12, "months");
                    if (this.selectedPeriod > 4) {
                        startValue = endValue.clone().add(1, "months");
                        endValue = endValue.add(12, "months");
                    }
                }
            }
        }

        const monthCount = firstMonthCount + periodsNumber * 12;
        const budgetEndDate = moment(this.budget.date).add(monthCount, "months");
        if (startValue.isAfter(budgetEndDate)) {
            startValue = budgetEndDate.clone().add(-11, "months");
            endValue = budgetEndDate.clone();
        }
        if (endValue.isAfter(budgetEndDate)) {
            endValue = budgetEndDate.clone();
            startValue = budgetEndDate.clone().add(-11, "months");
        }
        this._startDate = startValue.format();
        this._endDate = endValue.format();
        this.skipCashFlowQuery = false;
        this.skipChartsQuery = false;
    }

    // async queryBudgetForecastFromBudget() {
    //     await this.computePeriodsList();
    //     this.selectPeriodFromBudget();
    //     this.skipBudgetForecastQuery = false;
    // }

    // queryBudgetForecastFromPeriods() {
    //     this.selectPeriodFromBudget();
    //     this.skipBudgetForecastQuery = false;
    // }
}

export default toNative(BudgetDiagram);
</script>
